<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Select a Profile';
                }
            },
            component_id: {
                default(){
                    return 'profile';
                }
            },
            frameColourInternal: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            frameMaterial: {
                required: true,
            },
            securedByDesign: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareEscutcheon: {
                required: true,
                default() {
                    return 0;
                }
            },
            openingDirection: {
                required: true,
            },
            doorRange: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameColourExternal, this.frameColourInternal, this.frameMaterial, this.securedByDesign, this.hardwareHandle, this.hardwareEscutcheon, this.openingDirection, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-profile?secured_by_design=' + this.securedByDesign + '&frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&frame_material=' + this.frameMaterial + '&hardware_handle=' + this.hardwareHandle + '&hardware_escutcheon=' + this.hardwareEscutcheon + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.frameMaterial + '_' + this.securedByDesign + '_' + this.hardwareHandle + '_' + this.hardwareEscutcheon + '_' + this.openingDirection + '_' + this.doorRange;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
